<div class="content" [style.display]="loaderShow ? 'flex' : 'none'">
  <img [style.width]="loaderSize + 'em'" src="assets/images/loader.svg" />
</div>
